import { useQuery } from '@tanstack/react-query'
import { getApplication, getMyReport, getMyResults } from '../api/endpoints'
import ResultsPanel from './ResultsPanel'
import ReportProgress from './ReportProgress'

export default function FinishedPage() {
  const app = useQuery({
    queryKey: ['application'], queryFn: getApplication,
    // Until scoring is done, check again every few seconds so the page moves on by itself.
    refetchInterval: (q) => (q.state.data && !['SCORED', 'REPORT_READY', 'WITHDRAWN', 'DISQUALIFIED'].includes(q.state.data.status) ? 5000 : false),
  })
  // Only asks for the report once scoring is done; polls while it is being prepared, and stops once it is ready or switched off.
  const scored = app.data && ['SCORED', 'REPORT_READY'].includes(app.data.status)
  const report = useQuery({
    queryKey: ['my-report'], queryFn: getMyReport, enabled: !!scored, staleTime: 0,
    refetchInterval: (q) => (q.state.data?.reason === 'NOT_READY' ? 5000 : false),
  })
  const results = useQuery({
    queryKey: ['my-results'], queryFn: getMyResults, enabled: !!scored, staleTime: 0,
    refetchInterval: (q) => (q.state.data?.reason === 'NOT_READY' ? 5000 : false),
  })
  const preparing = !!app.data && !scored
  const notReady = results.data?.reason === 'NOT_READY' || report.data?.reason === 'NOT_READY'
  const closed = app.data && ['WITHDRAWN', 'DISQUALIFIED'].includes(app.data.status)
  return (
    <div className="card stack">
      {closed ? (
        <>
          <h1>Your application is closed</h1>
          <p>Please contact the admissions office if you have questions.</p>
        </>
      ) : (
        <>
          <h1>All done, thank you</h1>
          <p>
            You have completed all your assessments.
            {results.data?.available ? ' Here are your results.' : ' The admissions team will review your results. There is nothing more you need to do here.'}
          </p>
          {report.data?.available && (
            <div className="notice ok">
              <p><strong>Your assessment report is ready.</strong>{report.data.provisional && !results.data?.available && ' Some percentiles are provisional until the test window closes.'}</p>
              <button className="primary" type="button" onClick={() => window.open(report.data!.url!, '_blank', 'noopener')}>Download your report (PDF)</button>
            </div>
          )}
          {results.data?.available && results.data.results && <ResultsPanel r={results.data.results} />}
          {preparing && <ReportProgress stage="scoring" />}
          {scored && notReady && <ReportProgress stage="report" compact={!!results.data?.available} />}
        </>
      )}
      {app.data && <p className="muted">Application {app.data.applicationNo}</p>}
    </div>
  )
}
